<template>
<v-container id="regular-tables-view" fluid tag="section">
    <material-card icon="mdi-filter" icon-small title="Suche" color="primary" class="mb-10">
      <v-row no-gutters>
          <v-col cols="2" sm="4" md="2" align-self="end">
            <v-text-field
              class="pa-4"
              v-model="filter.bezeichnung"
              label="Suchbegriff"
            ></v-text-field>
          </v-col>
        </v-row>
</material-card>

<material-card
      v-if="loading === false"
      icon="mdi-mortar-pestle-plus"
      icon-small
      title="Artikel"
      color="primary"
    >
    <v-data-table
        :headers="headers"
        :items="itemsFiltered"
        :items-per-page="50"
        class="pl-5 pr-5"
      >
        <template v-slot:item.pzn="{ item }">
            {{ item.pzn }}
        </template>
        <template v-slot:item.artikelname="{ item }">
            {{ item.artikelname }}
        </template>
        <template v-slot:item.menge="{ item }">
            {{ item.menge }}
        </template>
        <template v-slot:item.apotheke1Bestand="{ item }">
          <span v-if="item.apotheke1Bestand > 0" style="color:green">Verfügbar</span>
          <span v-if="item.apotheke1Bestand <= 0" style="color:red">Nicht verfügbar</span>
        </template>
        <template v-slot:item.apotheke2Bestand="{ item }">
            <span v-if="item.apotheke2Bestand > 0" style="color:green">Verfügbar</span>
          <span v-if="item.apotheke2Bestand <= 0" style="color:red">Nicht verfügbar</span>
        </template>
        <template v-slot:item.apotheke3Bestand="{ item }">
             <span v-if="item.apotheke3Bestand > 0" style="color:green">Verfügbar</span>
            <span v-if="item.apotheke3Bestand <= 0" style="color:red">Nicht verfügbar</span>
        </template>
    </v-data-table>
    
</material-card>

<div v-if="loading === true" class="text-center pt-5">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>


</v-container>
</template>

<script>  
  import axios from "axios";

  export default {
    name: 'HamburgCluster',
    components: {
    
    },
  props: {
    
  },
  data() {
    return {
      items: {
        apotheke1Name: '',
        apotheke2Name: '',
        apotheke3Name: '',
        artikel: [],
      }, 
      itemsFiltered: [],
      headers: [
        {
          text: "PZN",
          align: "start",
          sortable: true,
          value: "pzn",
        },{
          text: "Name",
          align: "start",
          sortable: true,
          value: "artikelname",
        },{
          text: "Menge",
          align: "start",
          sortable: false,
          value: "menge",
        },{
          text: "Apotheke 1",
          align: "start",
          sortable: false,
          value: "apotheke1Bestand",
        },{
          text: "Apotheke 2",
          align: "start",
          sortable: false,
          value: "apotheke2Bestand",
        },{
          text: "Apotheke 3",
          align: "start",
          sortable: false,
          value: "apotheke3Bestand",
        },
      ],
      filter: {
        bezeichnung: null,
      },  
      loading: false,   
    }
  },
  methods: {
    async load() {
      try {    
        
        this.loading = true;
        
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(apiUrl + "/hamburgCluster/getLagerbestandHamburg");  

        if (response) {          
          this.items = response.data;

          this.headers[3].text = this.items.apotheke1Name;
          this.headers[4].text = this.items.apotheke2Name;
          this.headers[5].text = this.items.apotheke3Name;

          this.itemsFiltered = this.items.artikel;

          this.loading = false;
        }

      } catch (e) {
        this.errors.push(e);
      }
    },
  },
  computed: {
      
  },
  watch: {
    filter: {
      handler(newData) {
        this.itemsFiltered = this.items.artikel;

        if (newData.bezeichnung) {          
          this.itemsFiltered = this.itemsFiltered.filter(function (el) {
            let res1 = false;            
            if (el.artikelname) {              
              res1 = el.artikelname.toLowerCase().includes(newData.bezeichnung.toLowerCase());
            }

            let res2 = false;            
            if (el.pzn) {
              res2 = el.pzn.toString().includes(newData.bezeichnung.toLowerCase());
            }

            return res1 || res2;
          });
        }
        else {
          return true;
        }        
      },      
      deep: true,
    }
  },
  async created() {
    await this.load();
  }
}

</script>

<stlyle scoped>
.my-colored-text {
  color: #ff0000;
}
</stlyle>
